import { useTranslation } from "react-i18next";
import { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import API from "../../utils/API";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import MScreen from "../../components/pos/MScreen";
import { StringUtils } from "../../utils/StringUtils";
import db from "../../db/db";
import { yellow } from "@mui/material/colors";
import { CircularProgress } from "@mui/material";
import AgGridQuickPurchaseList from "./AgGridQuickPurchaseList";
import PODetails from "./PODetails";
import POSummary from "./POSummary";
import PConfirm from "../../components/pos/PConfirm";
import PDialog from "../../components/pos/PDialog";
import ProductCrud from "../product/ProductCrud";
import GenericReportViewer from "../reports/GenericReportViewer";
import { SyncUtils } from "../../utils/SyncUtils";
import MCostQtyInputDialog from "./MCostQtyInputDialog";
import BarcodeReader from "react-barcode-reader";

const theme = createTheme({
  components: {
    MuiInputBase: {
      input: {
        fontSize: "1.9rem",
        fontWeight: "bold",
        padding: 4,
      },
      root: {
        fontSize: "1.9rem",
        fontWeight: "bold",
        padding: 4,
      },
    },
    MuiGrid: { item: { padding: 4 } },
    MuiOutlinedInput: {
      input: {
        padding: 4,
        marginLeft: 2,
      },
      styleOverrides: {
        root: {
          marginLeft: 0,
        },
        input: {
          padding: 4,
          marginLeft: 2,
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          fontSize: ".95rem",
          padding: "5px",
        },
        head: {
          lineHeight: "2rem",
          fontSize: "1rem",
          padding: 0,
          color: "#fff",
          backgroundColor: "#00695c !important",
        },
        paddingCheckbox: {
          width: 0,
        },
      },
    },
    MUIDataTableBodyRow: {
      styleOverrides: {
        root: {
          "&:nth-child(odd)": {
            backgroundColor: yellow[50],
          },
        },
      },
    },
    MuiTypography: { root: { fontSize: "0.9rem" } },
    MuiAutocomplete: {
      styleOverrides: {
        root: {
          '[class*="MuiOutlinedInput-root"] ': {
            padding: 0,
          },
        },
      },
    },
  },
});

//MuiAutocomplete-root .MuiOutlinedInput-root .MuiAutocomplete-input

export default function MPurchaseCrud(props) {
  const { t } = useTranslation();

  const translate = t;

  const [anchorEl, setAnchorEl] = useState(null);

  const [refereneNumber, setReferenenumber] = useState("AUTO");
  const [refereneNumberError, setReferenenumberError] = useState("");
  const [vendor, setVendor] = useState("");
  const [vendorError, setVendorError] = useState("");
  const [vendorOptions, setVendorOptions] = useState([]);
  const [paymentMode, setPaymentMode] = useState({
    name: "CREDIT",
    id: "CREDIT",
  });

  const [paymentModeError, setPaymentModeError] = useState("");
  const [paymentTerms, setPaymentterms] = useState("");
  const [paymentTermsError, setPaymenttermsError] = useState("");
  const [paymentTermsOptions, setPaymenttermsOptions] = useState([
    { name: "7 DAYS", id: 1 },
    { name: "10 DAYS", id: 6 },
    { name: "15 DAYS", id: 2 },
    { name: "30 DAYS", id: 3 },
    { name: "45 DAYS", id: 7 },
    { name: "60 DAYS", id: 8 },
    { name: "90 DAYS", id: 4 },
    { name: "100 DAYS", id: 5 },
  ]);
  const [invoiceNumber, setInvoiceNumber] = useState("");
  const [invoiceNumberError, setInvoiceNumberError] = useState("");
  const [transactionDate, setTransactionDate] = useState("");
  const [transactionDateError, setTransactionDateError] = useState("");

  const [note, setNote] = useState("");
  const [noteError, setNoteError] = useState("");
  const [filesList, setFilesList] = useState([]);

  const [currentScreen, setCurrentScreen] = useState("po_crud");
  const [purchaseItems, setPurchaseItems] = useState([]);
  const [summary, setSummary] = useState(getDefaultSummar());
  const [amount, setAmount] = useState("");
  const [errorAmount, setErrorAmount] = useState("");

  const [showProgressDialog, setShowProgressDialog] = useState(false);
  const [progressMessage, setProgressMessage] = useState("");

  const [discountTypeOptions, setDiscountTypeOptions] = useState([
    { name: "None", id: "0" },
    { name: "After Tax", id: "1" },
    { name: "Before Tax", id: "2" },
  ]);
  const [paymentMmodeOptions, setpaymentMmodeOptions] = useState([
    { name: "CREDIT", id: "CREDIT" },
    { name: "CASH", id: "CASH" },
  ]);

  const [costCalculationType, setCostCalculationType] = useState({
    name: "Cost from Received Cost",
    id: "COST_FROM_RECEIVED_COST",
  });
  const [costCalculationTypeOptions, setCostCalculationTypeOptions] = useState([
    {
      name: "Cost from Received Cost",
      id: "COST_FROM_RECEIVED_COST",
    },
    { name: "Cost from Final Cost", id: "COST_FROM_FINAL_COST" },
  ]);

  const [taxTypeOptions, setTaxTypeOptions] = useState([
    { name: "Include Tax", id: "1" },
    { name: "Exclude Tax", id: "2" },
    { name: "No Tax", id: "3" },
  ]);

  const [isConsolidated, setConsolidated] = useState(true);
  const [taxType, setTaxType] = useState({ name: "Include Tax", id: "1" });

  const [liveValidation, setLiveValidation] = useState(false);
  const [roundoffAmount, setRoundffAmount] = useState("0.00");
  const [confirmContext, setConfirmContext] = useState({ open: false });
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [expectedDate, setExpectedDate] = useState("");
  const [expectedDateError, setExpectedDateError] = useState("");
  const [purchaseOrderObj, setPurchaseOrderObj] = useState();

  const [productInfoFields, setProductInfoFields] = useState([]);
  const [storeAdminSetting, setStoreAdminSetting] = useState();
  const [showProductCrud, setShowProductCrud] = useState(false);
  const [productObject, setProductObject] = useState(null);
  const [pricingLevels, setPricingLevels] = useState([]);
  const [unitTypeOptions, setUnitTypeOptions] = useState([]);

  const [prodLookupValue, setProdLookupValue] = useState();

  const [activeProduct, setActiveProduct] = useState(null);
  const [currentCost, setCurrentCost] = useState(0);
  const [currentQty, setCurrentQty] = useState(0);
  const [showControls, setShowControls] = useState(true);

  useEffect(() => {
    loaadByDB();
    populateVendor();
  }, []);

  useEffect(() => {
    if (liveValidation && (amount === "" || amount == 0)) {
      setErrorAmount("Required Invoice Amount");
    } else {
      if (amount) {
        setRoundffAmount(
          StringUtils.formattedNumberWithStoreDecimal(
            parseFloat(amount) - parseFloat(summary.finalAmount),
            props.context
          )
        );
      } else {
        setRoundffAmount(
          StringUtils.formattedNumberWithStoreDecimal(0, props.context)
        );
      }
      setErrorAmount("");
    }
  }, [amount]);

  useEffect(() => {
    if (invoiceNumber != null && invoiceNumber != "") setInvoiceNumberError("");
  }, [invoiceNumber]);

  useEffect(() => {
    console.log(">> origObjectId", props.origObjectId);
    if (props.origObjectId) {
      populatePurchaseOrder(props.origObjectId);
    }
  }, [props.origObjectId]);

  function handleWIthTaxChangeEvent(value) {
    setTaxType(value);
    let datList = [...purchaseItems];
    for (let i = 0; i < datList.length; i++) {
      updatevalues(datList[i], "TAX_CHANGE", value, null);
    }
    setPurchaseItemsWrapper(datList);
  }

  function handleCostCalculationTypeChangeEvent(value) {
    setCostCalculationType(value);
  }

  async function loaadByDB() {
    let dbData = await db.config.where("name").equals("UNIT_TYPES").toArray();
    setUnitTypeOptions(JSON.parse(dbData[0].configTxt));

    let dbData2 = await db.config
      .where("name")
      .equals("PRODUCT_INFO_CUSTOM_FIELDS")
      .toArray();
    if (dbData2 && dbData2.length == 1) {
      setProductInfoFields(JSON.parse(dbData2[0].configTxt));
    }

    let storeAdminVal = await db.setting
      .where("sKey")
      .equals("store_admin")
      .toArray();
    if (storeAdminVal && storeAdminVal[0] && storeAdminVal[0].sValue)
      setStoreAdminSetting(JSON.parse(storeAdminVal[0].sValue));
  }

  async function populatePurchaseOrder(purchaseOrderId) {
    try {
      showProgress(true, "Loading");
      if (props.mode == "view") {
        setShowControls(false);
      }
      let { data } = await API.get("/api/v1/purchaseorder/" + purchaseOrderId);
      await populateData(data);
    } catch (err) {
      console.log(err);
      props.showMessage(
        "error",
        translate("Not able to retrive purchase order data from server")
      );
    }
    showProgress(false, "Loading");
  }

  function rejectdBarcode(barcode) {
    console.log("Rejected Barcode :", barcode);
  }

  function onBarcodeScanned(barcode) {
    console.log("Scuccess Barcode :", barcode);
    findProductByBarcode(barcode);
  }

  async function findProductByBarcode(barcode) {
    let dbData = await db.product
      .where("barcodeList")
      .equals(barcode)
      .toArray();
    if (dbData.length == 0) {
      props.showMessage("warning", "Product Not Found");
    } else {
      let productBean = dbData[0];
      let pricingBean = getPricingFromBarcode(productBean, barcode);
      await addProductToTable(productBean, pricingBean);
    }
  }

  function getPricingFromBarcode(productBean, barcode) {
    for (let pricing of productBean.productPricingBeanList) {
      for (let barcodeBean of pricing.productBarcodeBeanList) {
        if (barcodeBean.barcode == barcode) {
          return pricing;
        }
      }
    }
  }

  async function populateData(inputData) {
    taxTypeOptions.map((item) => {
      if (item.id == inputData.taxTypeValue) {
        setTaxType(item);
      }
    });
    setPurchaseOrderObj(inputData);

    let costCalculationTypeTemp;
    if (inputData.costCalculationTypeName && inputData.costCalculationTypeId) {
      costCalculationTypeTemp = {
        name: inputData.costCalculationTypeName,
        id: inputData.costCalculationTypeId,
      };
    } else {
      costCalculationTypeTemp = {
        name: "Cost from Received Cost",
        id: "FROM RECEIVED COST",
      };
    }
    let vSummary = getDefaultSummar();
    if (inputData.discountTypeText && inputData.discountTypeValue) {
      vSummary.discountType = {
        name: inputData.discountTypeText,
        id: inputData.discountTypeValue,
      };
    } else {
      vSummary.discountType = {
        name: "After Tax",
        id: "1",
      };
    }

    let sn = 1;
    let data = [];

    for (let item of inputData.orderItems) {
      let productData = [];

      let dbProduct = await db.product
        .where("id")
        .equals(item.productId)
        .toArray();

      if (dbProduct.length == 0) {
        productData = await API.get(
          "/api/v1/product/" + item.productId + "?includeDeleted=true"
        );
      }

      let qty =
        item.receivedQty && parseFloat(item.receivedQty) > 0
          ? item.receivedQty
          : item.quantity && parseFloat(item.quantity) > 0
          ? item.quantity
          : 0;
      let orderItem = [
        { v: sn },
        { v: item.productName },
        { v: item.unitType },
        {
          v: qty,
        },
        { v: { foc: item.isIncludeFocQty, focQty: item.focQty } },
        { v: item.actualCost },
        { v: item.lineItemDiscountAmount ? item.lineItemDiscountAmount : 0 },
        {
          v: item.actualCost * qty,
        },
        { v: item.taxPercentage },
        { v: { name: item.taxTypeText, id: item.taxTypeValue } },
        { v: item.taxCost },
        {
          v:
            item.receivedCostWithoutTax &&
            parseFloat(item.receivedCostWithoutTax) > 0
              ? item.receivedCostWithoutTax
              : 0,
        },
        {
          v:
            item.receivedNetCost && parseFloat(item.receivedNetCost) > 0
              ? item.receivedNetCost
              : 0,
        },
        {
          info: {
            productBean:
              dbProduct.length == 0 ? productData.data : dbProduct[0],
            // productBean: dbProduct.data,
            pricingBean: null,
            selected: false,
            calculationType: costCalculationTypeTemp,
          },
        },
      ];
      data.push(orderItem);
      sn++;
    }
    console.log("##1");

    setPurchaseItems(data);

    vSummary.discount = inputData.subTotalDiscountAmount;
    updateSummary(data, vSummary);

    setAmount(inputData.amount);
    setRoundffAmount(inputData.roundoffAmount);

    setReferenenumber(inputData.orderId);
    setVendor({
      id: inputData.vendorId,
      name: inputData.displayVendorName,
      bean: inputData.vendorBean,
    });
    setPaymentMode({
      name: inputData.paymentMode,
      id: inputData.paymentModeId,
    });
    setPaymentterms({
      name: inputData.paymentTerms,
      id: inputData.paymentTermsId,
    });
    setCostCalculationType(costCalculationTypeTemp);
    setInvoiceNumber(inputData.invoiceNumber);
    setTransactionDate(inputData.settlementDate);
    setExpectedDate(inputData.expectedDate);
    setNote(inputData.settlementNote);
    populateFile(inputData);
  }

  async function populateFile(inputData) {
    try {
      let fileData = [];
      let arr = inputData.fileId.split(",");
      let count = 1;
      for (let i = 0; i < arr.length; i++) {
        let { data } = await API.post("/api/v1/filelist", [arr[i]]);
        data.forEach((element) => {
          let file = new Object();
          file["serialNumber"] = count;
          file["fileName"] = element.fileName;
          file["fileType"] = element.fileType;
          file["fileSizeText"] = element.fileSize;
          file["fileData"] = element.fileData;
          file["fileTypeText"] = element.fileTypeText;
          file["imageData"] = element.imageData;
          file["fileId"] = element.id;
          fileData.push(file);
          count++;
        });
      }
      setFilesList(fileData);
    } catch (err) {
      console.log(err);
    }
  }

  function getItemIndex(productId, itemList) {
    let index = null;
    for (let i = 0; i < itemList.length; i++) {
      if (itemList[i][13].info.productBean.id == productId) {
        index = i;
        break;
      }
    }
    return index;
  }

  function resetSelection(data, rowIndex) {
    for (let i = 0; i < data.length; i++) {
      if (rowIndex == i) {
        data[i][13].info.selected = true;
        setActiveProduct(data[i][13].info.productBean);
        setCurrentQty(data[i][3].v);
        console.log(data[i]);
        setCurrentCost(data[i][5].v ? data[i][5].v : 0);
        console.log("FFC-", data[i][13].info);
      } else data[i][13].info.selected = false;
    }
  }

  //TODO
  async function onLinkClikedForProductCrud(id) {
    try {
      let { data } = await API.get("/api/v1/product/" + id);
      setProductObject(data);
      setShowProductCrud(true);
      //setOpenWindow(true);
    } catch (err) {
      console.log(err);
      props.showMessage(
        "error",
        translate("Not able to retrive Product data from server")
      );
    }
  }

  async function populateVendor() {
    db.vendor.toArray(function (data) {
      let dat = [];
      for (let i = 0; i < data.length; i++) {
        if (!data[i].parent_id) {
          dat.push({ id: data[i].id, name: data[i].name, bean: data[i] });
        }
      }
      setVendorOptions(dat);
    });
  }

  function getDefaultSummar() {
    return {
      qty: StringUtils.formattedNumberWithStoreDecimal(0, props.context),
      total: StringUtils.formattedNumberWithStoreDecimal(0, props.context),
      totalWoTax: StringUtils.formattedNumberWithStoreDecimal(0, props.context),
      totalTax: StringUtils.formattedNumberWithStoreDecimal(0, props.context),
      discountType: {
        name: "None",
        id: "0",
      },
      discount: StringUtils.formattedNumberWithStoreDecimal(0, props.context),
      finalAmount: StringUtils.formattedNumberWithStoreDecimal(
        0,
        props.context
      ),
      finalAmountExTax: StringUtils.formattedNumberWithStoreDecimal(
        0,
        props.context
      ),
      finalTax: StringUtils.formattedNumberWithStoreDecimal(0, props.context),
      roundoffAmount: StringUtils.formattedNumberWithStoreDecimal(
        0,
        props.context
      ),
    };
  }

  async function addProductToTable(productBean, pricingBean, rowIx) {
    setActiveProduct(productBean);
    var data = [...purchaseItems];
    let itemIndex = getItemIndex(productBean.id, data);
    sessionStorage.setItem("enableAutoScroll", "true");
    if (itemIndex != null && isConsolidated) {
      updatePurchaseItemQty(data, itemIndex, 0);
    } else {
      let sn = data.length + 1;

      let dbCost = await db.cost
        .where("productId")
        .equals(productBean.id)
        .toArray();

      console.log("dbCOst", dbCost);

      let derivedCost = pricingBean.cost;

      if (taxType.id == "1") {
        derivedCost = StringUtils.formattedNumber(
          parseFloat(derivedCost) +
            parseFloat(derivedCost) *
              (parseFloat(productBean.taxBean.rate) / 100),
          props.context.store.currencyDecimal
        );
      }

      let orderItem = [
        { v: sn },
        { v: productBean.name },
        { v: pricingBean.unitType },
        { v: 0 },
        { v: { foc: false, focQty: 0 } },
        { v: derivedCost },
        { v: 0 },
        { v: 0 },
        {
          v:
            productBean.taxBean != null &&
            (productBean.taxBean != null) != undefined
              ? productBean.taxBean.rate
              : "0",
        },
        {
          v: taxType
            ? { name: taxType.name, id: taxType.id }
            : { name: "Include Tax", id: "1" },
        },
        { v: "0" },
        { v: "0" },
        { v: "0" },
        {
          info: {
            productBean: productBean,
            pricingBean: pricingBean,
            selected: false,
            calculationType: costCalculationType,
          },
        },
      ];
      console.log("rowIx", rowIx);
      if (rowIx != null) {
        data[rowIx] = orderItem;
        resetSelection(data, rowIx);
      } else {
        data.push(orderItem);
        resetSelection(data, data.length - 1);
      }
      setPurchaseItemsWrapper(data);
      if (props.mobile) {
        setCurrentQty(1);
        setCurrentCost(derivedCost ? derivedCost : 0);
        setCurrentScreen("capture_cost_qty");
      }
    }
  }

  function updatePurchaseItemQty(itemList, index, newValue) {
    resetSelection(itemList, index);
    setPurchaseItemsWrapper(itemList);
  }

  function setPurchaseItemsWrapper(poItems) {
    setPurchaseItems(poItems);
    updateSummary(poItems, summary);
  }

  function updateSummary(poItems, pSummary) {
    let s = {
      qty: 0,
      total: 0,
      totalWoTax: 0,
      totalTax: 0,

      finalAmount: 0,
      finalAmountExTax: 0,
      finalTax: 0,
    };

    let total = 0;
    poItems.map((value) => {
      total = total + parseFloat(value[12].v ? value[12].v : 0);
    });

    poItems.map((value) => {
      s.qty += parseFloat(value[3].v ? value[3].v : 0);
      s.totalTax += parseFloat(value[10].v ? value[10].v : 0);
      s.totalWoTax += parseFloat(value[11].v ? value[11].v : 0);
      s.total += parseFloat(value[12].v ? value[12].v : 0);

      let distributionRatio = parseFloat(value[12].v ? value[12].v : 0) / total;

      let fCost = parseFloat(value[12].v ? value[12].v : 0);
      let fTax = parseFloat(value[10].v ? value[10].v : 0);
      let fCostWoTax = parseFloat(value[11].v ? value[11].v : 0);
      if (pSummary.discount && parseFloat(pSummary.discount) > 0) {
        if (pSummary.discountType.id == "1") {
          fCost = fCost - parseFloat(pSummary.discount) * distributionRatio;
          fCostWoTax = fCost / (1 + parseFloat(value[8].v) / 100);
          fTax = fCost - fCostWoTax;
        }
        if (pSummary.discountType.id == "2") {
          //Before Tax
          fCostWoTax =
            fCostWoTax - parseFloat(pSummary.discount) * distributionRatio;
          fTax = (fCostWoTax * parseFloat(value[8].v)) / 100;
          fCost = fCostWoTax + fTax;
        }
      }
      s.finalAmount += fCost;
      s.finalAmountExTax += fCostWoTax;
      s.finalTax += fTax;
    });

    let sum = { ...summary };
    sum.qty = s.qty;
    sum.total = StringUtils.formattedNumberWithStoreDecimal(
      s.total,
      props.context
    );
    sum.totalWoTax = StringUtils.formattedNumberWithStoreDecimal(
      s.totalWoTax,
      props.context
    );
    sum.totalTax = StringUtils.formattedNumberWithStoreDecimal(
      s.totalTax,
      props.context
    );

    sum.finalAmount = StringUtils.formattedNumberWithStoreDecimal(
      s.finalAmount,
      props.context
    );
    sum.finalAmountExTax = StringUtils.formattedNumberWithStoreDecimal(
      s.finalAmountExTax,
      props.context
    );
    sum.finalTax = StringUtils.formattedNumberWithStoreDecimal(
      s.finalTax,
      props.context
    );
    sum.discount = pSummary.discount;
    sum.discountType = pSummary.discountType;

    setSummary(sum);
    setAmount(sum.finalAmount);
  }

  function updateSummaryValue(key, value) {
    console.log(key, value);
    let sum = { ...summary };
    if (key == "discount") {
      sum.discount = value;
    }
    if (key == "discountType") {
      sum.discountType = value;
      if (sum.discountType.id == 0) sum.discount = 0;
    }
    updateSummary(purchaseItems, sum);
  }

  function updatevalues(rowData, valType, value, colIndex) {
    if (colIndex != null) rowData[colIndex] = value;

    let receivedQty = 0;
    let foc = {};
    let taxType1 = {};
    let receivedCost = 0;
    let taxPercentage = 0;
    let taxCost = 0;
    let costWithoutTax = 0;
    let finalCost = 0;
    let discount = 0;
    let costAfterDiscount = 0;

    if (rowData[3]) receivedQty = rowData[3].v ? rowData[3].v : 0;
    if (rowData[4]) foc = rowData[4].v;
    if (rowData[5]) receivedCost = rowData[5].v ? parseFloat(rowData[5].v) : 0;
    if (rowData[6]) discount = rowData[6].v ? parseFloat(rowData[6].v) : 0;
    if (rowData[7])
      costAfterDiscount = rowData[7].v ? parseFloat(rowData[7].v) : 0;
    if (rowData[8]) taxPercentage = rowData[8].v;
    if (rowData[9]) taxType1 = taxType;
    if (valType === "TAX_CHANGE") {
      taxType1 = value;
    } else if (rowData[9].v) {
      taxType1 = rowData[9].v;
    }
    if (rowData[10]) taxCost = rowData[10].v;
    if (rowData[11]) costWithoutTax = rowData[11].v;
    if (rowData[12]) finalCost = rowData[12].v;

    if (valType == "RECEIVED_QTY") {
      console.log(">>", value.v);
      receivedQty = value.v ? value.v : 0;
      if (costCalculationType.id === "COST_FROM_RECEIVED_COST") {
        costAfterDiscount = receivedQty * receivedCost - discount;
        costWithoutTax = costAfterDiscount;
      }
    } else if (valType == "foc") {
      foc = value.v;
    } else if (valType == "RECEIVED_COST") {
      receivedCost = value.v ? value.v : 0;
      costAfterDiscount = receivedQty * receivedCost - discount;
      costWithoutTax = costAfterDiscount;
    } else if (valType === "DISCOUNT") {
      discount = value.v ? value.v : 0;
      costAfterDiscount = receivedQty * receivedCost - discount;
      costWithoutTax = costAfterDiscount;
    } else if (valType == "TAX_CHANGE") {
      taxType1 = { name: value.name, id: value.id };
      if (costCalculationType.id === "COST_FROM_RECEIVED_COST") {
        costAfterDiscount = receivedQty * receivedCost - discount;
        costWithoutTax = costAfterDiscount;
      }
    } else if (valType == "FINAL_COST") {
      finalCost = value.v ? value.v : 0;
    }

    if (costCalculationType.id === "COST_FROM_FINAL_COST") {
      taxCost = 0;
      if (taxType1.id == "1") {
        /*Include Tax*/
        taxPercentage = taxPercentage == null ? 0 : taxPercentage;
        taxCost = (parseFloat(finalCost) * parseFloat(taxPercentage)) / 100;
        costWithoutTax = finalCost - taxCost;
        costAfterDiscount = finalCost;
        receivedCost =
          finalCost / (receivedQty ? (receivedQty != 0 ? receivedQty : 1) : 1);
      } else if (taxType1.id == "2") {
        /*Exclude Tax*/
        taxPercentage = taxPercentage == null ? 0 : taxPercentage;
        taxCost =
          (parseFloat(finalCost) * parseFloat(taxPercentage)) /
          (100 + parseFloat(taxPercentage));
        costWithoutTax = finalCost - taxCost;
        costAfterDiscount = costWithoutTax;

        receivedCost =
          costWithoutTax /
          (receivedQty ? (receivedQty != 0 ? receivedQty : 1) : 1);
      } else {
        costWithoutTax = finalCost;
        costAfterDiscount = finalCost;
        receivedCost =
          finalCost / (receivedQty ? (receivedQty != 0 ? receivedQty : 1) : 1);
      }
    } else if (valType != "foc") {
      taxCost = 0;
      if (taxType1.id == "1") {
        /*Include Tax*/
        taxPercentage = taxPercentage == null ? 0 : taxPercentage;
        taxCost =
          (parseFloat(costWithoutTax) * parseFloat(taxPercentage)) /
          (100 + parseFloat(taxPercentage));
        finalCost = costWithoutTax;
        costWithoutTax = costWithoutTax - taxCost;
      } else if (taxType1.id == "2") {
        /*Exclude Tax*/
        taxPercentage = taxPercentage == null ? 0 : taxPercentage;
        taxCost = (costWithoutTax * taxPercentage) / 100;
        finalCost = taxCost + costWithoutTax;
      } else {
        finalCost = costWithoutTax;
      }
    }
    setVal(rowData, 3, receivedQty, valType, "RECEIVED_QTY");
    setVal(rowData, 4, foc, valType, "foc");
    setVal(rowData, 5, receivedCost, valType, "RECEIVED_COST");
    setVal(rowData, 6, discount, valType, "DISCOUNT");
    setVal(rowData, 7, costAfterDiscount, valType, "COST_AFTER_DISCOUNT");
    setVal(rowData, 8, taxPercentage, valType, "TAX_PER");
    setVal(rowData, 9, taxType1, valType, "TAX_TYPE");
    setVal(rowData, 10, taxCost, valType, "TAX_COST");
    setVal(rowData, 11, costWithoutTax, valType, "COST_WITHOUT_TAX");
    setVal(rowData, 12, finalCost, valType, "FINAL_COST");
  }

  function setVal(rowData, index, value, valType, dataType) {
    if (valType === dataType) {
      if (dataType === "foc") {
        rowData[index] = { v: { foc: value.foc, focQty: value.focQty } };
      } else {
        rowData[index] = { v: value, e: "" };
      }
    } else {
      if (dataType === "foc" && value) {
        rowData[index] = {
          v: {
            foc: value.foc,
            focQty: value.focQty,
          },
        };
      } else if (dataType === "TAX_TYPE" && value) {
        rowData[index].v = value;
      } else {
        if (isFinite(value)) {
          rowData[index] = {
            v: StringUtils.formattedNumberWithStoreDecimal(
              value,
              props.context
            ),
            e: "",
          };
        } else {
          rowData[index] = { v: "", e: "" };
        }
      }
    }
  }

  var biRef = {};

  async function onSave() {
    setConfirmContext({
      title: "Are You Sure",
      message: "Are you sure to post the order,This action can't revert!",
      type: "warning",
      open: true,
      yes: true,
      no: true,
      confirmContextType: "SAVE",
      saveType: props.poType == "LPO" ? "REQUESTED" : "SETTLED",
    });
    setConfirmOpen(true);
    /*Save action implemented in function onYesNoClicked*/
  }

  function showProgress(flag, message) {
    if (message) {
      setProgressMessage(message);
    }
    setShowProgressDialog(flag);
  }

  function onDelete() {
    setConfirmContext({
      title: "Are You Sure",
      message: "Are you sure to delete the order,This action can't revert!",
      type: "warning",
      open: true,
      yes: true,
      no: true,
      confirmContextType: "DELETE",
    });
    setConfirmOpen(true);
  }

  function showDetailedError(msg) {
    if (biRef && biRef.requestCrud)
      biRef.requestCrud.parentEvent("validation", msg);
    props.showMessage("error", msg.message);
  }

  async function onSaveDraft() {
    onYesNoClicked({ saveType: "DRAFT" }, "yes", "SAVE");
  }

  async function onSaveAndPrint() {
    setConfirmContext({
      title: "Are You Sure",
      message: "Are you sure to post the order,This action can't revert!",
      type: "warning",
      open: true,
      yes: true,
      no: true,
      confirmContextType: "SAVE",
      saveType: "REQUESTED",
      print: true,
    });
    setConfirmOpen(true);
  }

  async function onYesNoClicked(context, value, confirmContextType) {
    setConfirmOpen(false);
    if (value == "yes") {
      if (confirmContextType == "SAVE") {
        var payload = createPayload(context.saveType);
        if (payload) {
          try {
            showProgress(true, "Saving");
            let { data } = await API.post("/api/v1/purchaseorder", payload);
            props.showMessage(
              "success",
              translate(
                props.poType +
                  (context.saveType == "DRAFT" ? " Saved " : " Created") +
                  " sucessfully"
              )
            );
            populatePurchaseOrder(data.id);
            if (props.onRefresh) props.onRefresh();

            if (context.print) {
              if (data.id) {
                let paramsList = [
                  {
                    key: "purchaseOrderId",
                    value: data.id,
                  },
                ];

                biRef.genericReportView.showGenericReportViewer(
                  "reports/generic/local_purchase_order",
                  paramsList,
                  "Purchase Request "
                );
              }
            }
            showProgress(false, "Saving");
            if (
              context.saveType == "SETTLED" ||
              context.saveType == "REQUESTED"
            ) {
              setShowControls(false);
            }
          } catch (err) {
            console.log(err);
            showProgress(false, "Saving");
            if (err.response && err.response.status == 412) {
              showDetailedError(err.response.data);
            } else {
              props.showMessage(
                "error",
                translate("Not able to settle Purchase Order")
              );
            }
          }
        }
      } else if (confirmContextType == "DELETE") {
        try {
          let result = await API.delete(
            "/api/v1/purchaseorder/" + purchaseOrderObj.id
          );
          props.showMessage("warning", translate("Purchase order got removed"));
          props.setCurrentScreen("");
          //TODO jose
          if (props.onRefresh) props.onRefresh();
        } catch (err) {
          console.log("error", err);
          props.showMessage(
            "error",
            translate("Not able to delete purchase order")
          );
        }
      }
    }
  }

  function validate() {
    let flag = true;
    if (!refereneNumber || refereneNumber === "") {
      setReferenenumberError(translate(" "));
      flag = false;
    }
    if (!vendor || vendor === undefined) {
      setVendorError(translate(" "));
      flag = false;
    }
    if (!paymentMode || paymentMode === "") {
      setPaymentModeError(translate(" "));
      flag = false;
    } else if (paymentMode.id === "CREDIT") {
      if (!paymentTerms || paymentTerms === undefined) {
        setPaymenttermsError(translate(" "));
        flag = false;
      }
    }
    if (props.poType == "GRN" || props.poType == "GRV") {
      if (!invoiceNumber || invoiceNumber === "") {
        setInvoiceNumberError(translate(" "));
        flag = false;
      }
    }
    if (!transactionDate || transactionDate === "") {
      setTransactionDateError(translate(" "));
      flag = false;
    }
    if (!flag) {
      props.showMessage("error", translate("Validation failed"));
    }
    return flag;
  }

  function createPayload(status) {
    let saveObject = {};
    if (status == "SETTLED" || status == "REQUESTED") {
      if (!validate()) {
        return;
      }
    } else {
      if (!vendor || vendor === undefined) {
        setVendorError(translate(" "));
        return;
      }
    }

    saveObject["orderId"] = refereneNumber;
    saveObject["vendorId"] = vendor.id;
    saveObject["vendorBean"] = vendor.bean;
    saveObject["date"] = transactionDate
      ? StringUtils.getIsoDate(transactionDate)
      : StringUtils.getIsoDate(new Date().getTime());
    saveObject["expectedDate"] = StringUtils.getIsoDate(expectedDate);

    saveObject["notes"] = note;
    //saveObject["status"] = "SETTLED";
    saveObject["paymentMode"] = paymentMode.name;
    saveObject["paymentTerms"] = paymentTerms.name;
    saveObject["paymentModeId"] = paymentMode.id;
    saveObject["paymentTermsId"] = paymentTerms.id;
    saveObject["isQuickEntry"] = true;
    saveObject["invoiceNumber"] = invoiceNumber;

    saveObject["settlementDate"] = StringUtils.getIsoDate(transactionDate);
    saveObject["settlementNote"] = note;
    saveObject["fileId"] = filesList.toString();

    if (
      (status == "SETTLED" || status == "REQUESTED") &&
      purchaseItems.length == 0
    ) {
      props.showMessage("error", translate("No products selected "));
      return null;
    }

    if (amount == "" || amount == 0) {
      props.showMessage("error", translate("Required Invoice Amount"));
      setErrorAmount("Required Invoice Amount");
      setLiveValidation(true);
      return null;
    }

    if (
      roundoffAmount &&
      (parseInt(roundoffAmount) > 1 || parseInt(roundoffAmount) < -1)
    ) {
      props.showMessage(
        "error",
        translate("The rounded amount cannot exceed 1.00")
      );
      return null;
    }

    let invoiceCheckRequired = false;
    if (status == "SETTLED" || status == "REQUESTED") {
      for (let i = 0; i < purchaseItems.length; i++) {
        let isFocChecked = purchaseItems[i][4] && purchaseItems[i][4].v.foc;
        let origQty =
          purchaseItems[i][3].v === "" ? 0 : parseFloat(purchaseItems[i][3].v);
        let focQty = isFocChecked
          ? parseFloat(
              purchaseItems[i][4].v.focQty === ""
                ? "0"
                : purchaseItems[i][4].v.focQty
            )
          : 0;

        if (origQty > 0) {
          invoiceCheckRequired = true;
        }

        let cost = parseFloat(
          purchaseItems[i][5].v === "" ? "0" : purchaseItems[i][5].v
        );

        if (origQty <= 0 && !isFocChecked) {
          props.showMessage(
            "error",
            "Validation failed, Quantity is required at row" +
              ":" +
              (parseInt(i) + 1).toString()
          );
          return null;
        }
        if (!isFocChecked && cost <= 0) {
          props.showMessage(
            "error",
            "Validation failed, Cost is required at row:" +
              (parseInt(i) + 1).toString()
          );
          return null;
        }
        if (isFocChecked && origQty > 0 && cost <= 0) {
          props.showMessage(
            "error",
            "Validation failed, Cost is required at row:" +
              (parseInt(i) + 1).toString()
          );
          return null;
        }

        if (isFocChecked && focQty <= 0) {
          props.showMessage(
            "error",
            "Validation failed, Foc Qty is required at row:" +
              (parseInt(i) + 1).toString()
          );
          return null;
        }
      }
    }
    saveObject["status"] = status;
    let orderItems = [];
    let count = 0;
    let actualCost = 0;
    let costWithoutTax = 0;
    purchaseItems.map((value) => {
      let ordeItem = Object.create(null);
      //ordeItem["productBean"] = value[13].info.productBean;
      ordeItem["productId"] = value[13].info.productBean.id;
      ordeItem["productName"] = value[1].v;
      ordeItem["unitType"] = value[2].v;
      ordeItem["quantity"] = value[3].v;
      ordeItem["productPricingId"] = null;
      ordeItem["actualCost"] = value[5].v;
      ordeItem["taxTypeValue"] = value[9].v.id;
      ordeItem["taxTypeText"] = value[9].v.name;
      ordeItem["taxPercentage"] = value[8].v;
      ordeItem["taxCost"] = value[10].v;
      ordeItem["netCost"] = value[12].v;
      ordeItem["isSettled"] = true;
      ordeItem["isIncludeFocQty"] = value[4].v.foc;
      ordeItem["focQty"] = value[4].v.focQty;

      //if (props.poType == "GRN" || props.poType == "GRV") {
      ordeItem["receivedTaxCost"] = value[10].v;
      ordeItem["receivedCostWithoutTax"] = parseFloat(value[11].v);
      ordeItem["receivedNetCost"] = parseFloat(value[12].v);
      ordeItem["receivedQty"] = value[3].v;
      //}

      ordeItem["lineItemDiscountAmount"] = parseFloat(value[6].v);
      orderItems.push(ordeItem);
      count = count + ordeItem.receivedQty;
      actualCost = actualCost + ordeItem.receivedNetCost;
      costWithoutTax += ordeItem.receivedCostWithoutTax;
    });
    saveObject["itemCount"] = count;
    saveObject["actualCost"] = actualCost;
    saveObject["totalExpectedCost"] = actualCost;
    saveObject["taxTypeValue"] = taxType.id;
    saveObject["taxTypeText"] = taxType.name;
    saveObject["orderItems"] = orderItems;
    saveObject["returnFlag"] = props.returnFlag;

    if (status == "SETTLED") {
      if (
        invoiceCheckRequired &&
        (!summary.finalAmountExTax || parseFloat(summary.finalAmountExTax) <= 0)
      ) {
        props.showMessage("error", "Invalid Total Amount");
        return null;
      }

      if (summary.discount && parseFloat(summary.discount) != 0) {
        if (
          parseFloat(summary.finalAmount) < 0 &&
          parseFloat(summary.discount) > 0
        ) {
          props.showMessage(
            "error",
            "Validation failed! Can not give more discount than Invoice Amount"
          );
          return null;
        }
      }
    }

    saveObject["totalAmountWithoutTax"] = summary.totalWoTax;
    saveObject["totalTaxAmount"] = summary.totalTax;
    saveObject["totalAmountWithTax"] = summary.total;
    saveObject["amount"] = amount;
    saveObject["roundoffAmount"] = roundoffAmount;
    saveObject["subTotalDiscountAmount"] = summary.discount;
    saveObject["discountTypeText"] = summary.discountType.name;
    saveObject["discountTypeValue"] = summary.discountType.id;

    if (
      summary.finalAmountExTax != null &&
      parseFloat(summary.finalAmountExTax) != 0
    ) {
      saveObject["invoiceAmount"] = StringUtils.formattedNumber(
        summary.finalAmountExTax,
        props.context.store.currencyDecimal
      );
    } else {
      saveObject["invoiceAmount"] = StringUtils.formattedNumber(
        actualCost,
        props.context.store.currencyDecimal
      );
    }

    /*let calculatedShippingCost = 0;
    let shippingCostAccountBeanList = [];
    costAccountMappingList.map((value) => {
      let ordeItem = Object.create(null);
      //ordeItem["fromAccountLedgerId"] = value.accountLedger.id;
      // ordeItem["fromAccountLedgerName"] = value.accountLedger.name;
      ordeItem["toAccountLedgerId"] = value.vendorAccount.id;
      ordeItem["toAccountLedgerName"] = value.vendorAccount.name;
      ordeItem["invoiceNumber"] = value.invoiceNumber;
      ordeItem["shippingCost"] = value.shippingAmount;
      ordeItem["taxPercentage"] = value.taxPercentage;
      ordeItem["date"] = value.date;
      ordeItem["description"] = value.description;
      shippingCostAccountBeanList.push(ordeItem);
      calculatedShippingCost += value.shippingAmount
        ? parseFloat(value.shippingAmount)
        : 0;
    });
    let savedShippingCost = StringUtils.formattedNumber(
      shippingCost ? shippingCost : 0,
      props.context.store.currencyDecimal
    );

    if (
      shippingCost &&
      calculatedShippingCost === parseFloat(savedShippingCost)
    ) {
      saveObject["shippingCost"] = savedShippingCost;
      saveObject["shippingCostAccountBeanList"] = shippingCostAccountBeanList;
    } else if (purchaseOrderObj) {
      saveObject["shippingCost"] = purchaseOrderObj.shippingCost
        ? purchaseOrderObj.shippingCost
        : 0;
      saveObject["shippingCostAccountBeanList"] =
        purchaseOrderObj.shippingCostAccountBeanList;
    }*/

    saveObject["orderType"] = props.poType;

    saveObject["costCalculationTypeName"] = costCalculationType.name;
    saveObject["costCalculationTypeId"] = costCalculationType.id;
    if (purchaseOrderObj && purchaseOrderObj.id) {
      saveObject["id"] = purchaseOrderObj.id;
      saveObject["intVersion"] = purchaseOrderObj.intVersion;
    } else {
      saveObject["id"] = null;
      saveObject["intVersion"] = 0;
    }

    return saveObject;
  }
  function productListRefresh() {}
  function onProductSaved(prodBean) {
    console.log(prodBean);
  }
  var biRef = {};

  async function prodSelected(newValue) {
    let [prodBean, pricingBean] = await SyncUtils.getProductBean(
      newValue.value
    );
    if (prodBean == null || pricingBean == null) {
      alert("Product got Deleted or Modifed, please Reload the Window");
    } else {
      addProductToTable(prodBean, pricingBean);
    }
    setProdLookupValue({ label: null, value: null });
  }

  const productLookupChanged = (newValue) => {
    prodSelected(newValue);
  };

  function onUpdateCostAndQty(qty, cost) {
    console.log(qty, cost);
    var data = [...purchaseItems];
    let itemIndex = getItemIndex(activeProduct.id, purchaseItems);
    if (itemIndex != null) {
      updatevalues(data[itemIndex], "RECEIVED_QTY", { v: qty }, null);
      updatevalues(data[itemIndex], "RECEIVED_COST", { v: cost }, null);

      setPurchaseItemsWrapper(data);
    }
  }

  let content = (
    <ThemeProvider theme={theme}>
      <BarcodeReader
        onError={rejectdBarcode}
        onScan={onBarcodeScanned}
        preventDefault={true}
        avgTimeByChar={
          props.context.storeAdmin.barcodeScanAvgTimeByChar
            ? props.context.storeAdmin.barcodeScanAvgTimeByChar
            : 30
        }
      ></BarcodeReader>
      <Grid
        container
        sx={{
          paddingLeft: "10px",
          paddingRight: "10px",
          paddingBottom: "10px",
        }}
      >
        <Grid item xs={12}>
          <PODetails
            poType={props.poType}
            taxTypeOptions={taxTypeOptions}
            costCalculationTypeOptions={costCalculationTypeOptions}
            refereneNumber={refereneNumber}
            refereneNumberError={refereneNumberError}
            vendor={vendor}
            vendorError={vendorError}
            vendorOptions={vendorOptions}
            paymentMode={paymentMode}
            paymentModeError={paymentModeError}
            paymentTerms={paymentTerms}
            paymentTermsError={paymentTermsError}
            paymentTermsOptions={paymentTermsOptions}
            invoiceNumber={invoiceNumber}
            invoiceNumberError={invoiceNumberError}
            transactionDate={transactionDate}
            expectedDate={expectedDate}
            note={note}
            noteError={noteError}
            setRefereneNumber={setReferenenumber}
            setRefereneNumberError={setReferenenumberError}
            setVendor={setVendor}
            setVendorError={setVendorError}
            setPaymentTerms={setPaymentterms}
            setPaymentTermsError={setPaymenttermsError}
            setInvoiceNumber={setInvoiceNumber}
            setInvoiceNumberError={setInvoiceNumberError}
            setTransactionDate={setTransactionDate}
            setExpectedDate={setExpectedDate}
            setPaymentMode={setPaymentMode}
            setPaymentModeError={setPaymentModeError}
            setNote={setNote}
            setNoteError={setNoteError}
            filesList={filesList}
            setFilesList={filesList}
            paymentMmodeOptions={paymentMmodeOptions}
            setCostCalculationType={setCostCalculationType}
            costCalculationType={costCalculationType}
            setConsolidated={setConsolidated}
            isConsolidated={isConsolidated}
            taxType={taxType}
            setTaxType={setTaxType}
            transactionDateError={transactionDateError}
            expectedDateError={expectedDateError}
            mobile={props.mobile}
            productLookupChanged={productLookupChanged}
            prodLookupValue={prodLookupValue}
            productCache={props.productCache}
            setOrigObject={setProductObject}
            setShowProductCrud={setShowProductCrud}
            handleWIthTaxChangeEvent={handleWIthTaxChangeEvent}
            handleCostCalculationTypeChangeEvent={
              handleCostCalculationTypeChangeEvent
            }
          ></PODetails>
        </Grid>
        <Grid item xs={12}>
          <AgGridQuickPurchaseList
            poType={props.poType}
            biRef={biRef}
            context={props.context}
            data={purchaseItems}
            updatevalues={updatevalues}
            updatePurchaseItemData={setPurchaseItemsWrapper}
            onAddProduct={addProductToTable}
            isConsolidated={isConsolidated}
            getItemIndex={getItemIndex}
            onLinkClikedForProductCrud={onLinkClikedForProductCrud}
            resetSelection={resetSelection}
            mobile={props.mobile}
            setCurrentScreen={setCurrentScreen}
          ></AgGridQuickPurchaseList>
        </Grid>
        <Grid item xs={12}>
          <POSummary
            poType={props.poType}
            summary={summary}
            amount={amount}
            setAmount={setAmount}
            discountTypeOptions={discountTypeOptions}
            updateSummaryValue={updateSummaryValue}
            roundoffAmount={roundoffAmount}
            onSave={onSave}
            onSaveDraft={onSaveDraft}
            onSaveAndPrint={onSaveAndPrint}
            mode={props.mode}
            context={props.context}
            purchaseOrderObj={purchaseOrderObj}
            onDelete={onDelete}
            mobile={props.mobile}
            showControls={showControls}
          ></POSummary>
        </Grid>
        <Grid item xs={12} sx={{ textAlign: "right" }}></Grid>
      </Grid>
    </ThemeProvider>
  );

  function getTitle() {}

  return (
    <div>
      {props.mobile && currentScreen === "po_crud" && (
        <MScreen
          title={props.title}
          isMoreMenuEnabled={true}
          rightAction="Save Draft"
          onRedirectToBack={() => props.setCurrentScreen("list_purchase")}
          enbaleRightAction={
            ((props.context.privileges.grn_grv_draft_edit &&
              (props.poType == "GRN" || props.poType == "GRV")) ||
              (props.context.privileges.lpo_lro_draft_edit &&
                props.poType == "LPO")) &&
            (!props.purchaseOrderObj ||
              props?.purchaseOrderObj?.status == "DRAFT")
          }
          onRightAction={onSaveDraft}
          content={content}
          context={props.context}
        ></MScreen>
      )}
      {!props.mobile && currentScreen === "po_crud" && (
        <MScreen
          title={props.title}
          isMoreMenuEnabled={true}
          onRedirectToHome={() => props.setCurrentPage("home")}
          onRedirectToBack={() => props.setCurrentScreen("list_purchase")}
          content={content}
          context={props.context}
        ></MScreen>
      )}

      {currentScreen === "capture_cost_qty" && (
        <MCostQtyInputDialog
          onUpdateValues={onUpdateCostAndQty}
          currentCost={currentCost}
          setCurrentCost={setCurrentCost}
          currentQty={currentQty}
          setCurrentQty={setCurrentQty}
          setCurrentScreen={setCurrentScreen}
        ></MCostQtyInputDialog>
      )}

      {confirmOpen && (
        <PConfirm
          open={confirmOpen}
          context={confirmContext}
          onButtonClicked={onYesNoClicked}
        ></PConfirm>
      )}
      {showProgressDialog && (
        <PDialog
          content={
            <Grid container style={{ width: 200, margin: 20 }}>
              <Grid item xs={12}>
                <CircularProgress disableShrink /> {progressMessage}
              </Grid>
            </Grid>
          }
          open={true}
          borderLess={true}
        ></PDialog>
      )}
      {showProductCrud && (
        <ProductCrud
          onRefresh={productListRefresh}
          readOnly={props.readOnly}
          showMessage={props.showMessage}
          showProgress={props.showProgress}
          hideProgress={props.hideProgress}
          setProgressMessage={props.setProgressMessage}
          setAlert={props.setAlert}
          context={props.context}
          productType="I"
          unitTypeOptions={unitTypeOptions}
          productInfoFields={productInfoFields}
          storeAdminSetting={storeAdminSetting}
          setShowCrud={setShowProductCrud}
          onProductSaved={onProductSaved}
          origObject={productObject}
          setOrigObject={setProductObject}
          pricingLevels={pricingLevels}
          //TODO mount promotion options
        ></ProductCrud>
      )}
      <GenericReportViewer
        biRef={biRef}
        showMessage={props.showMessage}
        setAlert={props.setAlert}
        context={props.context}
      ></GenericReportViewer>
    </div>
  );
}
